import getEnvConfig from "@efcloud/el-b2b-get-env-config"
import deepmerge from "deepmerge"

export default deepmerge({
  paramsInvalid: "paramsInvalid",
  userInvalid: "userInvalid",
  studentInvalid: "studentInvalid",
  internalError: "internalError",
  help: "destinationHelpUrl?EFID=${EFID}&LNG=${LNG}",
  upsell: "destinationUpsellUrl?EFID=${EFID}&LNG=${LNG}",
  refer: "destinationReferUrl?EFID=${EFID}"
}, getEnvConfig("redirect"))
